// extracted by mini-css-extract-plugin
module.exports = {"badge":"styles_badge__Gi1wr","verified":"styles_verified__ZnvnY","unverified":"styles_unverified___8m9f"};